module.exports = __webpack_public_path__ + "img/calendar-user-circle-yellow.6c857d5e.svg";